import { Link } from 'found'
import React, { Component } from 'react'
import { createFragmentContainer } from 'react-relay'
import graphql from 'babel-plugin-relay/macro' 

import videoIcon from '../../images/video-white.svg'
import readingIcon from '../../images/reading-icon_white.svg'

class FeaturedStorySection extends Component {

    constructor() {
        super()
        this.state = { ctaHover: false }
    }

    render() {
        return (
            <div
                className="section-4"
                style={{ background: this.props.group.color + '88' }}
            >
                <div className="div-block-21 w-clearfix">
                    <Link
                        to={this.props.link}
                        style={{
                            textTransform: 'uppercase',
                            borderColor: this.props.group.color,
                            backgroundColor: this.state.ctaHover ? '#ffffff' : this.props.group.color,
                            color: this.state.ctaHover ? this.props.group.color : '#ffffff',
                        }}
                        className="explore-oslo w-button"
                        onMouseEnter={() => this.setState({ ctaHover: true })}
                        onMouseLeave={() => this.setState({ ctaHover: false })}
                    >
                        {this.props.callToAction}
                    </Link>
                    <Link to={this.props.articleLink}>
                        <div
                            className="div-block-123"
                            style={{
                                backgroundImage: 'url(' + this.props.picture + ')'
                            }}
                        >
                            <div className="link-7">{this.props.title}</div>
                        </div>
                        <div className="div-block-22">
                            <div className="div-block-23">
                                <img alt=""  style={{marginLeft:'0'}} src={this.props.videoLink ? videoIcon : readingIcon} width={70} className="image-30" />
                                <div style={{ textTransform: 'uppercase' }} className="span">
                                    {this.props.group.name}
                                </div>
                                <div className="text-block-20">{this.props.caption}</div>
                            </div>
                        </div>
                    </Link>
                </div>
            </div>
        )
    }
}

const connectRelay = HomePage => class extends Component {

    render() {
        const { home } = this.props
        const { routeResolver } = this.props.context
        const group = home.featuredStory.city || home.featuredStory.category

        const props = {
            title: home.featuredStory.title,
            caption: home.featuredStory.caption,
            videoLink: home.featuredStory.videoLink,
            articleLink: routeResolver.article.get(group.slug, home.featuredStory.slug),
            group,
            callToAction: `Explore ${group.name}`,
            link: (
                home.featuredStory.city ?
                routeResolver.location.get(home.featuredStory.city.slug) :
                routeResolver.category.get(home.featuredStory.category.slug)
            ),
            picture: home.featuredStory.widePicture ? home.featuredStory.widePicture : home.featuredStory.picture,
        }

        return <FeaturedStorySection {...props} />
    }
}

export default createFragmentContainer(
    connectRelay(FeaturedStorySection),
    graphql`
        fragment featuredStorySection_home on Home {
            featuredStory {
                slug
                title
                caption
                widePicture
                picture
                videoLink
                city {
                    slug
                    name
                    color
                }
                category {
                    slug
                    name
                    color
                }
            }
        }
    `
)
